import React, { PureComponent } from "react";
import { isNumber, toString, toNumber } from "lodash";
import { RunnerOddsAtom, Strong, Span } from "./styled-components";

const getRunnerOddQALabelSuffix = (isFavorite, isScratched) => {
  if (isScratched) {
    return "-scratched";
  }

  if (isFavorite) {
    return "-favorite";
  }

  return "";
};

export default class RunnerOdds extends PureComponent {
  static defaultProps = {
    isScratched: false,
    isSelected: false,
    isFavorite: false,
    currentOddsNumerator: null,
    currentOddsDenominator: null,
    morningLineOddsNumerator: null,
    morningLineOddsDenominator: null
  };

  renderOddDenominator() {
    return (
      (isNumber(this.props.currentOddsDenominator) &&
        `/${toString(this.props.currentOddsDenominator)}`) ||
      ""
    );
  }

  renderOdd() {
    if (!this.props.isScratched) {
      if (!isNumber(this.props.currentOddsNumerator)) {
        return "n/a";
      }
      return `${toString(
        this.props.currentOddsNumerator
      )}${this.renderOddDenominator()}`;
    }

    return "scr";
  }

  renderMorningLineDenominator() {
    return (
      (toNumber(this.props.morningLineOddsDenominator) > 1 &&
        `/${toString(this.props.morningLineOddsDenominator)}`) ||
      ""
    );
  }

  renderMorningLine() {
    if (isNumber(this.props.morningLineOddsNumerator)) {
      return `${
        this.props.morningLineOddsNumerator
      }${this.renderMorningLineDenominator()}`;
    }
    return "n/a";
  }

  render() {
    return (
      <RunnerOddsAtom
        data-qa-label={`runnerOdds${getRunnerOddQALabelSuffix(
          this.props.isFavorite,
          this.props.isScratched
        )}`}
        scratched={this.props.isScratched}
        favorite={this.props.isFavorite && !this.props.isScratched}
      >
        <Strong qaLabel="runnerOdds-odd">{this.renderOdd()}</Strong>
        <Span qaLabel="runnerOdds-morningLineOdd">
          {this.renderMorningLine()}
        </Span>
      </RunnerOddsAtom>
    );
  }
}
